import { patchState, signalStore, withMethods, withProps, withState } from "@ngrx/signals";
import { GridListItem } from "../../services/grids.service";
import { s25Resource } from "../../util/s25.resource";
import { LynxService } from "../../services/lynx.service";
import { TelemetryService } from "../../services/telemetry.service";

type State = {
    grid: GridListItem | undefined;
};

export const AcademicGridsStore = signalStore(
    // Managed state
    withState(<State>{
        grid: undefined,
    }),
    // Resources
    withProps((store) => ({
        expSecEnabled: s25Resource({ defaultValue: false, loader: LynxService.getExpSecEnabled }),
    })),
    // State methods
    withMethods((store) => ({
        selectGrid: (grid: GridListItem | undefined) => {
            patchState(store, { grid: grid });
            if (grid) TelemetryService.sendWithSub("MPG", "Academic", "View");
        },
        exitGrid: () => {
            patchState(store, { grid: undefined });
        },
    })),
);
